import React from 'react';
import step1 from '../assets/images/step-1.png';
import step2 from '../assets/images/step-2.png';
import step3 from '../assets/images/step-3.png';

export default function HowItWorks() {
  return (
    <section id="how" className="how">
      <div className="wave" aria-hidden="true">
        <svg viewBox="0 0 1000 80" preserveAspectRatio="none">
          {/* Fewer, deeper waves along the top (swapped) */}
          <path
            d="M0 40 Q 125 5 250 40 T 500 40 T 750 40 T 1000 40"
            fill="none"
            stroke="var(--primary)"
            strokeWidth="2"
            opacity="0.25"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="container">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">
         Big change starts small. We all get overwhelmed by endless to-do lists. Moro brings things back to basics, one shared daily task that reminds you to pause, breathe, and do something meaningful.
        </p>

        <div className="hiw-grid">
          {/* Step 1 */}
          <div className="hiw-col">
            <div className="hiw-step">1</div>
            <img className="hiw-image" src={step1} alt="Get a daily challenge" />
            <h3 className="hiw-heading">Get a daily challenge</h3>
            <p className="hiw-text">We pick one small, doable task. Add personal tasks you want.</p>
          </div>

          {/* Step 2 */}
          <div className="hiw-col">
            <div className="hiw-step">2</div>
            <img className="hiw-image" src={step2} alt="Finish in minutes" />
            <h3 className="hiw-heading">Finish in minutes</h3>
            <p className="hiw-text">Simple tasks you can complete quickly — build momentum fast.</p>
          </div>

          {/* Step 3 */}
          <div className="hiw-col">
            <div className="hiw-step">3</div>
            <img className="hiw-image" src={step3} alt="Track streaks & feel good" />
            <h3 className="hiw-heading">Track streaks & feel good</h3>
            <p className="hiw-text">Celebrate small wins and keep going — tomorrow looks better.</p>
          </div>
        </div>
      </div>
      <div className="wave wave-bottom" aria-hidden="true">
        <svg viewBox="0 0 1000 80" preserveAspectRatio="none">
          {/* Smooth, equal waves across the bottom (swapped) */}
          <path
            d="M0 40 Q 50 22 100 40 T 200 40 T 300 40 T 400 40 T 500 40 T 600 40 T 700 40 T 800 40 T 900 40 T 1000 40"
            fill="none"
            stroke="var(--primary)"
            strokeWidth="2"
            opacity="0.25"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </section>
  );
}